import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initNativeBridge } from '@/utils/platform'

// iOS WKWebView: input blur 时重置 viewport zoom（SPA 跳页后 zoom 不自动重置）
if (typeof document !== 'undefined') {
  document.addEventListener('blur', () => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]')
    if (!meta) return
    const content = meta.content
    meta.content = content + ', maximum-scale=1.0'
    requestAnimationFrame(() => { meta.content = content })
  }, true)
}

initNativeBridge()

const startPath = import.meta.env.VITE_START_PATH
if (startPath && window.location.pathname === '/') {
  window.history.replaceState(null, '', startPath)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
